import { styled } from "@mui/material/styles";
import Button from "../../../../../../components/Button";
import { COLORS } from "../../../../../../themes/colors";

export const Styles = {
  FormContainer: styled("form")(() => ({
    display: "flex",
    flexDirection: "column",
    marginTop: "8px"
  })),

  ButtonRow: styled("div")(() => ({
    display: "flex",
    gap: "12px",
    marginTop: "16px",
  })),

  CancelButton: styled(Button)(() => ({
    border: `1px solid ${COLORS.PRIMARY.BLUE.MAIN}`
  }))
};
